// extracted by mini-css-extract-plugin
export var button = "_ds-4";
export var hasDarkBackground = "_ds-7";
export var hasLightBackground = "_ds-6";
export var iconWrapper = "_ds-0";
export var large = "_ds-2";
export var medium = "_ds-1";
export var small = "_ds-5";
export var xsmall = "_ds-3";